// Category data + projects per category.
// New projects can be added to the `projects` array of each category later.

export const CATEGORIES = [
  {
    slug: "on-ground-activations",
    label: "Brand Activation & Events",
    tagline: "Experiences designed to bring brands into the real world.",
    lede:
      "From high-impact brand installations to immersive consumer experiences, we create physical moments that invite people to stop, engage and remember.",
    coverImage:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_work-portfolio-239/artifacts/yfywq79l_On-ground%20Activation.png",
    events: [
      {
        id: "gshock-tgsfi-2024",
        logo: "/projects/gshock-logo.png",
        logoClass: "h-[2.072rem] md:h-[2.527rem]",
        logoAlt: "G-SHOCK logo",
        title: "The Great Sneaker Fest India",
        meta: "Pop-up Experience · Gurgaon · 2024",
        image: {
          src: "/projects/gshock-hero.webp",
          alt: "G-SHOCK pop-up pavilion glowing in red neon at night",
        },
        copy: "Translating G-SHOCK's brand personality into a living experiential space — industrial, grunge and ready for the streets — through graffiti, neon accents and skate culture cues. Anchored by a life-size watch face installation, the pavilion became a standout photo-op while showcasing the watch range and enabling on-spot sales.",
        detail: {
          brand: "G-SHOCK",
          name: "G-SHOCK",
          subtitle: "Pop Up Experience",
          description: "The Great Sneaker Fest India (TGSFI), Gurgaon | 2024",
          gallery: [
            {
              src: "/projects/gshock-night.webp",
              alt: "G-SHOCK pavilion glowing in red neon at night",
            },
            {
              src: "/projects/gshock-day.webp",
              alt: "G-SHOCK pavilion exterior by day, wrapped in graffiti art",
            },
            {
              src: "/projects/gshock-display.webp",
              alt: "Watch and sneaker display case inside the G-SHOCK pavilion",
            },
            {
              src: "/projects/gshock-wall.webp",
              alt: "Watch-face feature wall with screen and graffiti detailing",
            },
            {
              src: "/projects/gshock-interior.webp",
              alt: "G-SHOCK pavilion interior — PROTECTION display wall and glass watch showcases with graffiti bases",
            },
          ],
        },
      },
      {
        id: "renault-rethink-2025",
        logo: "/projects/renault-logo.png",
        logoClass: "h-[3.15rem] md:h-[3.8rem]",
        logoAlt: "Renault logo",
        title: "Life-size Graffiti Installation",
        meta: "IGI Airport Art · Gurgaon · 2025",
        image: {
          src: "/projects/renault-hero.webp",
          alt: "Renault rethink installation glowing against a dusk sky at IGI Airport",
        },
        copy: "This installation artwork created for Renault in India is a large-format experiential airport terminal sculpture that merges brand identity with vibrant Indian visual culture. At the base of the structure appears the phrase “renault. rethink.”, reinforcing the brand’s message of innovation, re-imagining mobility, and fresh perspectives.",
        detail: {
          brand: "Renault",
          name: "Renault",
          subtitle: "IGI Airport Art Installation",
          gallery: [
            {
              src: "/projects/renault-feature.webp",
              alt: "Renault rethink installation at IGI Airport against a golden sunset, with manicured hedges and the air traffic control tower",
            },
            {
              src: "/projects/renault-2.webp",
              alt: "Renault installation glowing against a purple dusk sky",
            },
            {
              src: "/projects/renault-3.webp",
              alt: "Renault installation glowing golden-yellow at dusk",
            },
            {
              src: "/projects/renault-4.webp",
              alt: "Close-up of the sculpted Renault diamond logo and graffiti artwork",
            },
            {
              src: "/projects/renault-5.webp",
              alt: "Side angle of the Renault installation with visitors at the airport gardens",
            },
          ],
        },
      },
      {
        id: "zepto-valentines-2026",
        logo: "/projects/zepto-logo.png",
        logoClass: "h-11 md:h-[3.3rem]",
        logoAlt: "Zepto logo",
        title: "Offline to Online",
        meta: "Valentine's Week · Delhi · 2026",
        image: {
          src: "/projects/zepto-hero.webp",
          alt: "Zepto Class of Prom '26 installation — a giant yearbook of creator portraits",
        },
        copy: "Curated a 300+ influencer-led experiential campaign for Zepto, transforming a single-day event into a 7-day content engine. Collab created an immersive, end-to-end experience integrating 10+ partner brands through content-first, interactive zones — delivering 800–1000+ pieces of creator content and a scalable content + commerce model for cultural moments.",
        detail: {
          brand: "Zepto",
          name: "Zepto",
          subtitle: "Offline to Online",
          description: "Pop-up Experience · Valentine's Week · Delhi · 2026",
          gallery: [
            {
              src: "/projects/zepto-1.webp",
              alt: "Zepto Valentine's Prom Night entrance — illuminated purple arch welcoming guests onto the lawn",
            },
            {
              src: "/projects/zepto-3.webp",
              alt: "Host interviewing a couple on the prom night floor under string lights and balloons",
            },
            {
              src: "/projects/zepto-4.webp",
              alt: "Hand-picked with love — Zepto Fresh dessert counter with chocolate-dipped strawberries",
            },
            {
              src: "/projects/zepto-5.webp",
              alt: "Prom king and queen crowned with sashes and red rose bouquets",
            },
            {
              src: "/projects/zepto-6.webp",
              alt: "Prom night lawn glowing under a canopy of drapes, bunting and fairy lights",
            },
            {
              src: "/projects/zepto-7.webp",
              alt: "Sunfeast Dark Fantasy red-carpet gifting zone with prize pedestals and velvet ropes",
            },
            {
              src: "/projects/zepto-8.webp",
              alt: "Couple sharing a Raffaello moment inside the glowing heart-shaped photo installation",
            },
            {
              src: "/projects/zepto-9.webp",
              alt: "Guests posing together under balloon-wrapped pillars and draped ceiling lights",
            },
            {
              src: "/projects/zepto-10.webp",
              alt: "Hershey's Kisses photo booth — Steal Kisses and a Picture Too marquee with guests",
            },
          ],
        },
      },
      {
        id: "swiggy-coke-cooking",
        logo: "/projects/swiggy-coke.png",
        logoAlt: "Swiggy × Coca-Cola logo",
        logoClass: "h-[2.586rem] md:h-[3.154rem]",
        title: "Coke Is Cooking",
        meta: "Immersive Food & Music Festival",
        image: {
          src: "/projects/coke-heart.webp",
          alt: "Coca-Cola × Swiggy heart-shaped installation at the Coke Is Cooking festival",
        },
        copy: "We created an immersive food and music festival experience for Coke, bringing the brand to life through a series of immersive installations, iconic brand moments, photo-led environments, live entertainment and integrated F&B experiences. The experience was designed to drive high recall, engagement and shareability, creating a vibrant, multi-sensory environment where audiences could discover, engage with and celebrate Coke.",
        detail: {
          brand: "Swiggy × Coca-Cola",
          name: "Swiggy × Coca-Cola",
          subtitle: "Coke Is Cooking",
          description: "Immersive Food & Music Festival · 2024",
          gallery: [
            {
              src: "/projects/swiggy-coke-1.webp",
              alt: "Coca-Cola × Swiggy entrance arch welcoming guests into the Coke Is Cooking festival",
            },
            {
              src: "/projects/swiggy-coke-2.webp",
              alt: "Pose Like a Pro — upside-down orange room photo installation",
            },
            {
              src: "/projects/swiggy-coke-3.webp",
              alt: "Coke Is Cooking giant boombox installation on the festival lawns",
            },
            {
              src: "/projects/swiggy-coke-4.webp",
              alt: "Coca-Cola bar counter with red stools serving festival guests",
            },
            {
              src: "/projects/swiggy-coke-5.webp",
              alt: "Rotating cube art wall of Coke and Swiggy food illustrations",
            },
            {
              src: "/projects/swiggy-coke-6.webp",
              alt: "Giant translucent red-and-orange heart installation with Coca-Cola × Swiggy branding",
            },
            {
              src: "/projects/swiggy-coke-7.webp",
              alt: "Coke Is Cooking main stage with full lighting rig and LED backdrop on the festival lawn",
            },
          ],
        },
      },
      {
        id: "teachers-barry-30",
        logo: "/projects/teachers-logo.png",
        logoAlt: "Teacher's logo",
        logoClass: "h-[2.99rem] md:h-[3.646rem]",
        detailLogoClass: "h-[5.74rem] md:h-[7.01rem]",
        title: "Teacher's EOD",
        meta: "On-Trade Activation — Barry 30",
        image: {
          src: "/projects/teachers-bar.webp",
          alt: "Teacher's Barry 30 activation — illuminated pour challenge at the bar",
        },
        copy: "Curated a youth-focused on-trade activation for Teacher's to drive trials and reposition the brand as fun, relevant, and engaging. Introduced “Barry 30” — a simple, high-recall challenge where consumers poured a perfect 30 ml serve to win their drink and a branded photo moment. Deployed across 80 resto-bars in 10 cities, the activation engaged 3,500+ consumers, delivering large-scale sampling while creating a playful, social experience that reconnected the brand with a younger audience.",
        detail: {
          brand: "Teacher's",
          name: "Teacher's",
          subtitle: "Teacher's EOD",
          description: "On-Trade Activation — Barry 30",
          gallery: [
            {
              src: "/projects/teachers-1.webp",
              alt: "Teacher's bar team in branded polos at the glowing back bar, bartender with illuminated serve tray",
            },
            {
              src: "/projects/teachers-2.webp",
              alt: "The Barry 30 pour ritual — measuring a perfect 30 ml serve on an illuminated tray",
            },
            {
              src: "/projects/teachers-3.webp",
              alt: "Guest pouring her own Teacher's 50 serve at the table during EOD Nights",
            },
            {
              src: "/projects/teachers-4.webp",
              alt: "Guests pouring and enjoying Teacher's at a resto-bar table on a rainy evening",
            },
            {
              src: "/projects/teachers-5.webp",
              alt: "Rooftop EOD Night — host engaging a table of guests over Teacher's serves",
            },
            {
              src: "/projects/teachers-6.webp",
              alt: "Guests trying the Barry 30 pour challenge at the bar with the illuminated serve tray",
            },
            {
              src: "/projects/teachers-7.webp",
              alt: "Guest raising a winning Teacher's pour at an outdoor resto-bar table",
            },
          ],
        },
      },
      {
        id: "godrej-laffaire-2023",
        logo: "/projects/godrej-logo.png",
        logoAlt: "Godrej L'Affaire logo",
        logoClass: "h-[3.576rem] md:h-[4.361rem]",
        detailLogoClass: "h-[5.06rem] md:h-[6.19rem]",
        title: "Interactive Brand Experience",
        meta: "Godrej L'Affaire · 2023",
        image: {
          src: "/projects/godrej-booth.webp",
          alt: "Godrej Capital interactive brand experience booth at L'Affaire",
        },
        copy: "An interactive game for Godrej's L'Affaire, turning the brand's financial story into a tech-led experience. Using Leap Motion, a Fruit Ninja–style game had users slice opportunities and dodge pitfalls — bringing to life how Godrej Capital helps you navigate life and build wealth wisely.",
        detail: {
          brand: "Godrej Capital",
          name: "Godrej Capital",
          subtitle: "Interactive Brand Experience",
          description: "Godrej L'Affaire · 2023",
          gallery: [
            {
              src: "/projects/godrej-1.webp",
              alt: "Godrej Capital interactive booth by day — game screen, colour-block panels and garden walls",
            },
            {
              src: "/projects/godrej-2.webp",
              alt: "Guests and the team at the Godrej Capital booth with the live game leaderboard",
            },
            {
              src: "/projects/godrej-3.webp",
              alt: "Leaderboard winner collecting her Godrej Capital gift bag at the booth",
            },
            {
              type: "video",
              src: "/projects/godrej-4.mp4",
              poster: "/projects/godrej-4-poster.webp",
              alt: "Guests playing the Leap Motion slice game at the Godrej Capital booth",
            },
          ],
        },
      },
      {
        id: "itc-sneaker-fest-2025",
        logo: "/projects/itc-logo.png",
        logoAlt: "ITC Limited logo",
        logoClass: "h-[4.92rem] md:h-[6.0rem]",
        detailLogoClass: "h-[5.74rem] md:h-[7.01rem]",
        title: "Unleash Your Passion",
        meta: "Indian Sneaker Festival · 2025",
        image: {
          src: "/projects/itc-event.webp",
          alt: "ITC Unleash Your Passion installation — neon arches and disco photo zones at the sneaker festival",
          pos: "object-top",
        },
        copy: "Bold Colours. Big Energy. Insta-worthy Vibes Only. Three zones. Endless vibes. The ultimate photo op. Moments turned into memories at the Sneaker Fest! #UnleashYourPassion",
        detail: {
          brand: "ITC",
          name: "ITC",
          subtitle: "Unleash Your Passion",
          description: "Indian Sneaker Festival · 2025",
          gallery: [
            {
              src: "/projects/itc-3.webp",
              alt: "Guests posing inside the glowing red arch at night under the lit Unleash Your Passion sign",
            },
            {
              src: "/projects/itc-1.webp",
              alt: "Unleash Your Passion zone by day — three arched rooms in red and blue with street-wear posters",
            },
            {
              src: "/projects/itc-2.webp",
              alt: "Front view of the ITC experiential zone — Burst 2 Slay rooms with disco balls and neon signage",
            },
          ],
        },
      },
      {
        id: "nandos-footfall-2023",
        logo: "/projects/nandos-logo.png",
        logoAlt: "Nando's logo",
        logoClass: "h-[4.92rem] md:h-[6.0rem]",
        detailLogoClass: "h-[6.89rem] md:h-[8.41rem]",
        title: "Footfall Activation",
        meta: "Mall Engagement · 2023",
        image: {
          src: "/projects/nandos-event.webp",
          alt: "Nando's Spin the Wheel mall activation with guests at the rooster wheel",
        },
        copy: "A simple yet effective mall activation turning passersby into diners through an interactive Spin the Wheel with instant rewards. Proving impact doesn't need complexity, it drove a 120% footfall uplift over the 10-day campaign.",
        detail: {
          brand: "Nando's",
          name: "Nando's",
          subtitle: "Footfall Activation",
          description: "Mall Engagement · 2023",
          gallery: [
            {
              src: "/projects/nandos-1.webp",
              alt: "Nando's Spin to Win rooster wheel installation on the mall atrium floor",
            },
            {
              src: "/projects/nandos-2.webp",
              alt: "Winner with his prize card at the Spin to Win wheel under the mall's golden ring",
            },
            {
              src: "/projects/nandos-3.webp",
              alt: "Guests posing with the team at the Nando's rooster wheel",
            },
            {
              src: "/projects/nandos-4.webp",
              alt: "Couple collecting their instant reward at the Nando's activation kiosk",
            },
            {
              src: "/projects/nandos-5.webp",
              alt: "Queue of shoppers waiting for their spin at the Nando's mall activation",
            },
          ],
        },
      },
      {
        id: "amazon-prime-day-vr",
        logo: "/projects/amazon-primeday-logo.png",
        logoAlt: "Amazon Prime Day logo",
        logoClass: "h-[2.948rem] md:h-[3.595rem]",
        title: "VR Shopping Experience",
        meta: "11 Days · 7 Cities · 10,000+ Experiences",
        image: {
          src: "/projects/amazon-event.webp",
          alt: "Amazon Prime Day cardboard ferris wheel installation with parcel-carrying figures",
        },
        copy: "The future of shopping brought forth by us in 7 cities prior to the biggest event for Amazon, 'Amazon Prime Day'.",
        detail: {
          brand: "Amazon Prime Day",
          name: "Amazon Prime Day",
          subtitle: "VR Shopping Experience",
          description: "11 Days · 7 Cities · 10,000+ Experiences",
          gallery: [
            {
              src: "/projects/amazon-1.webp",
              alt: "Amazon Prime Day tower installation glowing with blue dots inside the mall atrium",
            },
            {
              src: "/projects/amazon-2.webp",
              alt: "Full Prime Day experience zone — delivery truck, tower and cardboard city in the mall",
            },
            {
              src: "/projects/amazon-3.webp",
              alt: "Cardboard ferris wheel with parcel-carrying figures and neon ring at the Prime Day zone",
            },
            {
              src: "/projects/amazon-4.webp",
              alt: "Prime Day blue experience truck with walk-in showroom parked on the city circuit",
            },
            {
              src: "/projects/amazon-5.webp",
              alt: "Rear view of the wrapped Prime Day truck carrying the Discover the Joy of More campaign",
            },
          ],
        },
      },
      {
        id: "ipev-indian-air-force",
        logo: "/projects/iaf-crest.png",
        logoAlt: "Indian Air Force crest",
        logoClass: "h-[4.92rem] md:h-[6.0rem]",
        detailLogoClass: "h-[7.76rem] md:h-[9.49rem]",
        title: "Induction Publicity Exhibition Vehicle",
        meta: "For Indian Air Force",
        image: {
          src: "/projects/ipev-event.webp",
          alt: "Indian Air Force IPEV mobile exhibition bus with young aspirants boarding",
        },
        copy: "A state-of-the-art mobile exhibition & engagement platform created for the Indian Air Force. It consisted of flight stimulators, History zones, career zones to give a truly experiential journey to the country's young & dynamic aspirants of the force.",
        detail: {
          brand: "Indian Air Force",
          name: "Indian Air Force",
          subtitle: "Induction Publicity Exhibition Vehicle",
          description: "For Indian Air Force",
          gallery: [
            {
              src: "/projects/ipev-5.webp",
              alt: "Front angle of the IAF exhibition bus with a group of aspirants gathered outside",
            },
            {
              src: "/projects/ipev-1.webp",
              alt: "IAF Induction Publicity Exhibition Vehicle wrapped in sky livery with students queuing to board",
            },
            {
              src: "/projects/ipev-2.webp",
              alt: "History zone inside the vehicle — backlit IAF photo wall and flight suit display",
            },
            {
              src: "/projects/ipev-3.webp",
              alt: "Students experiencing the flight simulator VR headsets inside the IPEV",
            },
            {
              src: "/projects/ipev-4.webp",
              alt: "IAF officer guiding school students through the exhibition zones inside the vehicle",
            },
          ],
        },
      },
      {
        id: "audi-driving-experience-2016",
        logo: "/projects/audi-driving-logo.png",
        logoAlt: "Audi Driving Experience logo",
        logoClass: "h-[3.254rem] md:h-[3.968rem]",
        detailLogoClass: "h-[4.73rem] md:h-[5.78rem]",
        title: "Audi Driving Experience",
        meta: "A multi-city driving experience showcasing Audi's Q-series and performance cars.",
        image: {
          src: "/projects/audi-event.webp",
          alt: "Yellow Audi R8 on the Buddh International Circuit track during the Audi Driving Experience",
        },
        copy: "34 Cities | 35 Q Drives | 8 Weekenders | 2 Sports Drives. A nationwide experiential programme designed to showcase Audi's SUV, sedan and sports car range through immersive driving experiences — covering 34 cities with 35 Q Drives, alongside 8 Weekenders and 2 Sports Drive experiences at the Buddh International Circuit.",
        detail: {
          brand: "Audi",
          name: "Audi",
          subtitle: "Audi Driving Experience",
          description: "Buddh International Circuit · Sports Drive",
          gallery: [
            {
              src: "/projects/audi-1.webp",
              alt: "Yellow Audi R8 parked on the Buddh International Circuit pit lane beside branded poster pillars",
            },
            {
              src: "/projects/audi-2.webp",
              alt: "Pit lane line-up under the red Audi driving experience banner at the Buddh International Circuit",
            },
            {
              src: "/projects/audi-3.webp",
              alt: "Guests posing on the track with the yellow Audi R8 sports car",
            },
            {
              src: "/projects/audi-4.webp",
              alt: "#AudiDrivingExperience red letter installation along the circuit grandstand",
            },
            {
              src: "/projects/audi-5.webp",
              alt: "Audi driving experience registration counter in signature red with branded backdrop",
            },
          ],
        },
      },
    ],
  },
  {
    slug: "conferences-launches-networking",
    label: "Conferences, Launches & Networking Events",
    tagline:
      "Rooms designed to convene, launch, and open doors between people.",
    lede:
      "Product reveals, private dinners, keynote conferences and networking evenings — produced end-to-end with an editor's eye for detail.",
    coverImage:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_work-portfolio-239/artifacts/f72wgkkv_Conferences%2C%20Launches%20%26%20Networking%20Events.webp",
    events: [
      {
        id: "republic-summit-2019",
        logo: "/projects/republic-summit-logo.png",
        logoAlt: "Republic Summit logo — RP-Sanjiv Goenka Group",
        logoClass: "h-[3.48rem] md:h-[4.244rem]",
        detailLogoClass: "h-[5.74rem] md:h-[7.01rem]",
        title: "India's Moment. Nation First",
        meta: "Republic Summit · 26–27 November 2019",
        image: {
          src: "/projects/republic-event.webp",
          alt: "Prime Minister Narendra Modi addressing the Republic Summit from the R. podium",
        },
        copy: "Attended by influential voices across politics and entertainment, with Narendra Modi and Amit Shah headlining days one and two. Speakers included Amitabh Kant, Jehangir Wadia, Nikhil Arora, Anil Kapoor, Kangana Ranaut, Arnab Goswami, Sri Sri Ravi Shankar, alongside leading Indian politicians.",
        detail: {
          brand: "Republic TV",
          name: "Republic TV",
          subtitle: "India's Moment. Nation First",
          description: "Republic Summit · 26–27 November 2019",
          gallery: [
            {
              src: "/projects/republic-1.webp",
              alt: "Bridging the Gap session on the Republic Summit ballroom stage with Sri Sri Ravi Shankar",
            },
            {
              src: "/projects/republic-2.webp",
              alt: "Arnab Goswami in conversation with Amit Shah on the Republic Summit stage",
            },
            {
              src: "/projects/republic-3.webp",
              alt: "Anil Kapoor session at the Republic Summit against the Nation First backdrop",
            },
            {
              src: "/projects/republic-4.webp",
              alt: "Prime Minister Narendra Modi addressing the Republic Summit from the R. podium",
            },
            {
              src: "/projects/republic-5.webp",
              alt: "The Republic Summit ballroom set with chandelier ceiling and full stage production",
            },
            {
              src: "/projects/republic-6.webp",
              alt: "Nation First installation — hexagon wall of summit speaker portraits in the foyer",
            },
            {
              src: "/projects/republic-7.webp",
              alt: "Sponsor hexagon wall and Durbar signage at the Republic Media Network entrance",
            },
            {
              src: "/projects/republic-8.webp",
              alt: "Sri Sri Ravi Shankar in conversation on the Republic Summit stage",
            },
          ],
        },
      },
      {
        id: "planet-india-g20-2023",
        logo: "/projects/planet-india-logo.png",
        logoAlt: "Planet India logo",
        logoClass: "h-[2.584rem] md:h-[3.151rem]",
        title: "G20 Cultural Evening",
        meta: "Bikaner House, New Delhi · 2023",
        image: {
          src: "/projects/planet-event.webp",
          alt: "Guests at the Planet India G20 Cultural Evening green wall",
        },
        copy: "An invite-only G20 evening bringing together policymakers, environmental leaders and global delegates for dialogue on sustainability and innovation. Featuring keynotes and a Planet India preview, the net-zero event embraced responsible practices and brought together prominent cultural, media and policy voices.",
        detail: {
          brand: "Planet India",
          name: "Planet India",
          subtitle: "G20 Cultural Evening",
          description: "Bikaner House, New Delhi · 2023",
          gallery: [
            {
              src: "/projects/planet-1.webp",
              alt: "Planet India living green wall with partner logos at the Bikaner House entrance",
            },
            {
              src: "/projects/planet-2.webp",
              alt: "Garden amphitheatre set with pallet seating and lamp posts ahead of the evening",
            },
            {
              src: "/projects/planet-3.webp",
              alt: "Hosts welcoming global delegates at dusk during the G20 Cultural Evening",
            },
            {
              src: "/projects/planet-4.webp",
              alt: "Keynote on the open-air stage under the trees with the Planet India preview on screen",
            },
            {
              src: "/projects/planet-5.webp",
              alt: "Guests watching the evening's talks from the amphitheatre seating",
            },
            {
              src: "/projects/planet-6.webp",
              alt: "Delegates in conversation under the draped canopy lounge at Bikaner House",
            },
            {
              src: "/projects/planet-7.webp",
              alt: "Wide night view of the open-air stage and amphitheatre audience",
            },
            {
              src: "/projects/planet-8.webp",
              alt: "Evening networking in the lantern-lit canopy lounge",
            },
            {
              src: "/projects/planet-9.webp",
              alt: "Guests with sapling gifts at the Planet India green wall",
            },
          ],
        },
      },
      {
        id: "laphroaig-networking-2024",
        logo: "/projects/laphroaig-logo.png",
        logoAlt: "Laphroaig logo",
        logoClass: "h-[2.152rem] md:h-[2.625rem]",
        detailLogoClass: "h-[2.7rem] md:h-[3.3rem]",
        title: "Experience Networking Event",
        meta: "2024–25 · Multi-City",
        image: {
          src: "/projects/laphroaig-event.webp",
          alt: "Laphroaig Unphorgettable bar installation with illuminated wolf artwork",
        },
        copy: "An intimate whisky series uniting collectors, influencers and tastemakers to build brand advocacy. Laphroaig's craft — peat cutting, floor malting and cold smoking — came alive through immersive installations, storytelling and a signature distillery wall. Guests engaged via tastings, conversations and personalised charcoal portraits inspired by its smoky character.",
        detail: {
          brand: "Laphroaig",
          name: "Laphroaig",
          subtitle: "Experience Networking Event",
          description: "2024–25 · Multi-City",
          gallery: [
            {
              src: "/projects/laphroaig-1.webp",
              alt: "LAPHROAIG statement wall lit on the event lawn at dusk",
            },
            {
              src: "/projects/laphroaig-2.webp",
              alt: "Unphorgettable bar counter with glowing wolf artwork and Laphroaig bottles",
            },
            {
              src: "/projects/laphroaig-3.webp",
              alt: "Floor Malting station — live screen, grain trough and tasting bowls",
            },
            {
              src: "/projects/laphroaig-4.webp",
              alt: "Cold Smoking station with kiln-fire visuals and smoke bowls",
            },
            {
              src: "/projects/laphroaig-5.webp",
              alt: "Peat Cutting station with landscape screen and spade backdrop",
            },
            {
              src: "/projects/laphroaig-6.webp",
              alt: "Guests dining on the lantern-lit lawn between pagoda bars",
            },
            {
              src: "/projects/laphroaig-7.webp",
              alt: "Brand host addressing guests with drams in hand at the evening soirée",
            },
            {
              src: "/projects/laphroaig-8.webp",
              alt: "Guests gathered at the glowing Unphorgettable bar installation at night",
            },
            {
              src: "/projects/laphroaig-9.webp",
              alt: "Laphroaig 10 poured over cocktails lined up on the bar",
            },
            {
              src: "/projects/laphroaig-10.webp",
              alt: "Guests toasting beside the Laphroaig heritage timeline wall",
            },
          ],
        },
      },
      {
        id: "isma-sugar-bioenergy-2023",
        logo: "/projects/sugar-conference-logo.png",
        logoAlt: "The India Sugar & Bio-Energy Conference logo",
        logoClass: "h-[4.035rem] md:h-[4.921rem]",
        detailLogoClass: "h-[5.74rem] md:h-[7.01rem]",
        title: "India Sugar & Bio-Energy Conference",
        meta: "2023 | New Delhi",
        image: {
          src: "/projects/isma-hero.webp",
          alt: "Panel session on The Future of Mobility at the India Sugar & Bio-Energy Conference",
        },
        copy: "The inaugural India Sugar & Bio-Energy Conference brought together government leaders, global stakeholders and industry pioneers for a two-day residential conference focused on the future of sugar, ethanol and bio-energy. Featuring keynote addresses, expert panels, forums and an industry expo, the event sparked dialogue around sustainability and the evolving sugar-ethanol sector, complemented by interactive exhibits, networking opportunities and a live performance by Indian Ocean.",
        detail: {
          brand: "India Sugar & Bio-Energy Conference",
          name: "India Sugar & Bio-Energy Conference",
          subtitle: "India Sugar & Bio-Energy Conference",
          description: "2023 | New Delhi",
          gallery: [
            {
              src: "/projects/isma-1.webp",
              alt: "#ISMA bottle-cap letter installation with sponsor standee at the conference expo",
            },
            {
              src: "/projects/isma-2.webp",
              alt: "Delegates registering at the India Sugar & Bio-Energy Conference welcome desk",
            },
            {
              src: "/projects/isma-3.webp",
              alt: "Delegate receiving the branded conference kit bag at registration",
            },
            {
              src: "/projects/isma-4.webp",
              alt: "Keynote by Shri Sanjeev Chopra in the main conference hall with twin LED screens",
            },
            {
              src: "/projects/isma-5.webp",
              alt: "Wide view of the packed conference hall during the Secretary's address",
            },
            {
              src: "/projects/isma-6.webp",
              alt: "The Future of Mobility panel at the India Sugar & Bio-Energy Conference podium",
            },
            {
              src: "/projects/isma-7.webp",
              alt: "Indian Ocean performing live on the conference evening stage",
            },
          ],
        },
      },
      {
        id: "isma-sugar-bioenergy-2024",
        logo: "/projects/sugar-conference-logo.png",
        logoAlt: "The India Sugar & Bio-Energy Conference logo",
        logoClass: "h-[4.035rem] md:h-[4.921rem]",
        detailLogoClass: "h-[5.74rem] md:h-[7.01rem]",
        title: "India Sugar & Bio-Energy Conference",
        meta: "2024 | New Delhi",
        image: {
          src: "/projects/isma2024-hero.webp",
          alt: "Dignitaries on stage at the inaugural session of the India Sugar & Bio-Energy Conference 2024",
        },
        copy: "The second edition of the India Sugar & Bio-Energy Conference saw higher industry participation and stronger policy presence, cementing its position as a key sector forum. Inaugurated by Shri Pralhad Joshi, Union Minister for Consumer Affairs, Food & Public Distribution, the conference featured keynotes, expert panels, an expanded expo and networking opportunities, with discussions on energy transition and the future of ethanol, alongside an evening of entertainment by Bolly Jazz.",
        detail: {
          brand: "India Sugar & Bio-Energy Conference",
          name: "India Sugar & Bio-Energy Conference",
          subtitle: "India Sugar & Bio-Energy Conference",
          description: "2024 | New Delhi",
          gallery: [
            {
              src: "/projects/isma2024-1.webp",
              alt: "The chandelier-lit ballroom set for the India Sugar & Bio-Energy Conference 2024",
            },
            {
              src: "/projects/isma2024-2.webp",
              alt: "Panel discussion at the India Sugar & Bio-Energy Conference 2024 with the speaker on the main LED screen",
            },
            {
              src: "/projects/isma2024-3.webp",
              alt: "Lamp-lighting ceremony at the inauguration of the India Sugar & Bio-Energy Conference 2024",
            },
            {
              src: "/projects/isma2024-4.webp",
              alt: "Speakers and dignitaries on stage at the India Sugar & Bio-Energy Conference 2024",
            },
            {
              src: "/projects/isma2024-5.webp",
              alt: "Wide view of the conference hall during a panel session at the India Sugar & Bio-Energy Conference 2024",
            },
            {
              src: "/projects/isma2024-6.webp",
              alt: "Panel discussion on key focus areas at the India Sugar & Bio-Energy Conference 2024",
            },
          ],
        },
      },
      {
        id: "isma-sugar-bioenergy-2025",
        logo: "/projects/sugar-conference-logo.png",
        logoAlt: "The India Sugar & Bio-Energy Conference logo",
        logoClass: "h-[4.035rem] md:h-[4.921rem]",
        detailLogoClass: "h-[5.74rem] md:h-[7.01rem]",
        title: "India Sugar & Bio-Energy Conference",
        meta: "2025 | New Delhi",
        image: {
          src: "/projects/sugar-event.webp",
          alt: "Lamp-lighting ceremony at the India Sugar & Bio-Energy Conference",
        },
        copy: "The third edition further elevated the platform with increased industry participation, a larger expo and stronger policy engagement. Inaugurated by Nitin Gadkari, the conference brought together senior government representatives, global stakeholders and industry leaders. The programme featured keynote addresses, panel discussions and breakout sessions, alongside an expanded expo with leading brands such as JCB and Maruti Suzuki, showcasing innovations shaping the future of bio-energy.",
        detail: {
          brand: "India Sugar & Bio-Energy Conference",
          name: "India Sugar & Bio-Energy Conference",
          subtitle: "India Sugar & Bio-Energy Conference",
          description: "2025 | New Delhi",
          gallery: [
            {
              src: "/projects/isma2025-1.webp",
              alt: "The India Sugar & Bio-Energy Conference 2025 letter installation at the venue entrance",
            },
            {
              src: "/projects/isma2025-2.webp",
              alt: "ISMA cube installation at the India Sugar & Bio-Energy Conference 2025",
            },
            {
              src: "/projects/isma2025-3.webp",
              alt: "ReGreen Excel sponsor booth at the India Sugar & Bio-Energy Conference 2025 expo",
            },
            {
              src: "/projects/isma2025-4.webp",
              alt: "Panel of industry leaders at the Energising Economies session, India Sugar & Bio-Energy Conference 2025",
            },
            {
              src: "/projects/isma2025-5.webp",
              alt: "Global Sugar Outlook session with a packed hall at the India Sugar & Bio-Energy Conference 2025",
            },
            {
              src: "/projects/isma2025-6.webp",
              alt: "Audience of delegates at the India Sugar & Bio-Energy Conference 2025",
            },
            {
              src: "/projects/isma2025-7.webp",
              alt: "Technology platforms keynote on the main screens at the India Sugar & Bio-Energy Conference 2025",
            },
          ],
        },
      },
      {
        id: "intellion-ipc-networking-2022",
        logo: "/projects/intellion-logo.png",
        logoAlt: "Intellion — Offices by Tata Realty logo",
        logoClass: "h-[3.03rem] md:h-[3.695rem]",
        title: "IPC Networking Evenings",
        meta: "Mumbai & Chennai · 2022",
        image: {
          src: "/projects/intellion-event.webp",
          alt: "Intellion Park launch stage with LED backdrop and green walls",
        },
        copy: "A relationship-led evening bringing Intellion's key IPC partners and property consultants together for updates, conversations and informal networking. Blending business with hospitality, stand-up by Jeeveshu and Rahul Subramanian, craft mixology, vertical garden photo moments, and a bespoke Aroma Bar for personalised fragrances.",
        detail: {
          brand: "IPC Networking Evenings",
          name: "IPC Networking Evenings",
          subtitle: "IPC Networking Evenings",
          description: "Mumbai & Chennai · 2022",
          gallery: [
            {
              src: "/projects/ipc-1.webp",
              alt: "Welcome desk at the Intellion Park themed entrance with vertical garden walls",
            },
            {
              src: "/projects/ipc-2.webp",
              alt: "Keynote address at the IPC Networking Evening ballroom — 'IT is built on strong values'",
            },
            {
              src: "/projects/ipc-3.webp",
              alt: "Launch presentation of Intellion's largest integrated office development on the LED screen",
            },
            {
              src: "/projects/ipc-4.webp",
              alt: "Guests blending personalised fragrances at the bespoke Aroma Bar",
            },
            {
              src: "/projects/ipc-5.webp",
              alt: "Stand-up performance in front of the Intellion Park LED backdrop",
            },
            {
              src: "/projects/ipc-6.webp",
              alt: "Keynote celebrating Ramanujan Intellion Park as India's first EDGE Zero Carbon project",
            },
            {
              src: "/projects/ipc-7.webp",
              alt: "Guests at round tables enjoying the stand-up act at the IPC Networking Evening ballroom",
            },
            {
              src: "/projects/ipc-8.webp",
              alt: "Aroma Booth with personalised fragrance blending against a vertical garden backdrop",
            },
            {
              src: "/projects/ipc-9.webp",
              alt: "Intellion and Tata Realty leadership group photo on the IPC Networking Evening stage",
            },
          ],
        },
      },
      {
        id: "ipc-third-hour-2024",
        logo: "/projects/intellion-park-logo.png",
        logoAlt: "Intellion Park logo",
        logoClass: "h-[2.776rem] md:h-[3.385rem]",
        title: "IPC Third Hour",
        meta: "Gurugram & Chennai · 2024",
        image: {
          src: "/projects/thirdhour-event.webp",
          alt: "IPC Third Hour — intimate Japanese-inspired networking dinner for Intellion partners",
        },
        copy: "Invite-only evenings connecting Intellion leadership with key IPC partners for deeper, deal-focused conversations. Inspired by a “Third Space,” the experience blended Japanese design, cuisine and whisky, anchored by a guided tasting. An immersive setup, from photo moments to branded tableware — created a relaxed, memorable networking environment.",
        detail: {
          brand: "IPC Third Hour",
          name: "IPC Third Hour",
          subtitle: "IPC Third Hour",
          description: "Gurugram & Chennai · 2024",
          gallery: [
            {
              src: "/projects/thirdhour-1.webp",
              alt: "Host addressing IPC partners from The Third Hour branded stage at the networking dinner",
            },
            {
              src: "/projects/thirdhour-2.webp",
              alt: "Speaker with microphone among guests at the Japanese-inspired Third Hour venue",
            },
            {
              src: "/projects/thirdhour-3.webp",
              alt: "Branded tableware, menu cards and cushions at a Third Hour dinner table setting",
            },
            {
              src: "/projects/thirdhour-4.webp",
              alt: "The Third Hour venue styled with globe pendant lights and curated artwork before guests arrive",
            },
            {
              src: "/projects/thirdhour-5.webp",
              alt: "Round tables dressed with The Third Hour branded cushions and tableware",
            },
          ],
        },
      },
      {
        id: "bmw-motorrad-bic-2016",
        logo: "/projects/bmw-logo.png",
        logoAlt: "BMW Motorrad logo",
        logoClass: "h-[4.92rem] md:h-[6.0rem]",
        title: "Motorrad",
        meta: "February 2016 · 100 PAX",
        image: {
          src: "/projects/bmw-event.webp",
          alt: "BMW Motorrad riders in leathers at the Buddh International Circuit",
        },
        copy: "At Buddh International Circuit, Greater Noida. For BMW motorcycle owners & prospective buyers.",
        detail: {
          brand: "Motorrad",
          name: "Motorrad",
          subtitle: "Motorrad",
          description: "February 2016 · 100 PAX",
          gallery: [
            {
              src: "/projects/bmw-1.webp",
              alt: "BMW Motorrad branded gantry and feather flags along the pit lane at Buddh International Circuit",
            },
            {
              src: "/projects/bmw-2.webp",
              alt: "Riders in leathers and helmets lined up on red BMW S 1000 XR motorcycles",
            },
            {
              src: "/projects/bmw-3.webp",
              alt: "Stunt rider performing a vertical wheelie on a BMW motorcycle at the Motorrad experience",
            },
            {
              src: "/projects/bmw-4.webp",
              alt: "BMW motorcycle owners group photo in racing leathers under the Motorrad gantry",
            },
            {
              src: "/projects/bmw-5.webp",
              alt: "Guest experiencing the EYE RIDE virtual reality simulator on a BMW S 1000 RR",
            },
          ],
        },
      },
      {
        id: "melbourne-roadshows-2023",
        logo: "/projects/melbourne-logo.png",
        logoAlt: "The University of Melbourne crest",
        logoClass: "h-[4.92rem] md:h-[6.0rem]",
        detailLogoClass: "h-[7.46rem] md:h-[9.11rem]",
        title: "India Recruitment Roadshows & Education Expo",
        meta: "2023–2025 · Delhi · Mumbai · Bengaluru",
        image: {
          src: "/projects/melbourne-hero.webp",
          alt: "University of Melbourne team with the mascot bear on stage at the India roadshow",
        },
        copy: "A multi-city series connecting prospective students and parents with The University of Melbourne's counsellors, faculty and leadership. The experience combined AR/VR campus tours, interaction zones, workshops and keynotes — offering a first-hand glimpse into academics, campus life and future pathways.",
        detail: {
          brand: "University of Melbourne",
          name: "University of Melbourne",
          subtitle: "India Recruitment Roadshows & Education Expo",
          description: "2023–2025 · Delhi · Mumbai · Bengaluru",
          gallery: [
            {
              src: "/projects/melbourne-1.webp",
              alt: "The University of Melbourne mascot bear with the roadshow team",
            },
            {
              src: "/projects/melbourne-2.webp",
              alt: "Guests registering at the University of Melbourne roadshow welcome desk",
            },
            {
              src: "/projects/melbourne-3.webp",
              alt: "Keynote on UoM and the Biomedical Precinct at the roadshow",
            },
            {
              src: "/projects/melbourne-4.webp",
              alt: "Engineering and IT faculty presentation at the University of Melbourne roadshow",
            },
            {
              src: "/projects/melbourne-5.webp",
              alt: "Attendees listening to a session at the University of Melbourne roadshow",
            },
            {
              src: "/projects/melbourne-6.webp",
              alt: "Faculty of Science keynote on the main stage at the University of Melbourne roadshow",
            },
            {
              src: "/projects/melbourne-7.webp",
              alt: "Students trying the VR campus tour at the University of Melbourne roadshow",
            },
            {
              src: "/projects/melbourne-8.webp",
              alt: "Guest fist-bumping the University of Melbourne mascot bear",
            },
            {
              src: "/projects/melbourne-9.webp",
              alt: "Speaker at the podium against the University of Melbourne campus backdrop",
            },
          ],
        },
      },
      {
        id: "under-armour-india-launch",
        logo: "/projects/under-armour-logo.png",
        logoAlt: "Under Armour logo",
        logoClass: "h-[3.82rem] md:h-[4.659rem]",
        detailLogoClass: "h-[4.39rem] md:h-[5.36rem]",
        title: "Under Armour India Brand Launch",
        meta: "Brand Launch | 1st Store in India",
        image: {
          src: "/projects/ua-launch-hero.webp",
          alt: "Michael Phelps with Under Armour leadership at the India brand launch",
        },
        copy: "Under Armour marked its India debut with the launch of its first store, creating a bold and immersive brand experience through a customized container setup. The launch brought together key global leaders and sporting icons, including former CEO Kevin Plank, President Patrick Frisk and celebrated Olympian Michael Phelps, making it a landmark moment for the brand's entry into the Indian market.",
        detail: {
          brand: "Under Armour",
          name: "Under Armour",
          subtitle: "India Brand Launch",
          description: "Brand Launch | 1st Store in India",
          gallery: [
            {
              src: "/projects/ua-launch-1.webp",
              alt: "The customized Under Armour container setup with #INDIAWILL letters at the India launch",
            },
            {
              src: "/projects/ua-launch-2.webp",
              alt: "Wide view of the Under Armour container installation at the mall courtyard",
            },
            {
              src: "/projects/ua-launch-3.webp",
              alt: "Media photographing Under Armour leadership on the #IndiaWill stage",
            },
            {
              src: "/projects/ua-launch-4.webp",
              alt: "Michael Phelps with Under Armour global leaders at the India launch",
            },
          ],
        },
      },
      {
        id: "under-armour-india-launch-b",
        logo: "/projects/under-armour-logo.png",
        logoAlt: "Under Armour logo",
        logoClass: "h-[3.82rem] md:h-[4.659rem]",
        detailLogoClass: "h-[4.39rem] md:h-[5.36rem]",
        title: "Under Armour Press Conference",
        meta: "Press Conference | Ambience Mall, Gurgaon",
        image: {
          src: "/projects/ua-event.webp",
          alt: "Under Armour India launch — Indian Ice Hockey Team and media at the press conference",
        },
        copy: "Under Armour hosted a high-impact press conference at Ambience Mall, Gurgaon, bringing the Indian Ice Hockey Team into the spotlight. The event brought together over 80 media professionals representing channels from across the country, creating a strong platform for media engagement and showcasing Under Armour\u2019s association with Indian ice hockey.",
        detail: {
          brand: "Under Armour",
          name: "Under Armour",
          subtitle: "Press Conference",
          description: "Press Conference | Ambience Mall, Gurgaon",
          gallery: [
            {
              src: "/projects/ua-press-1.webp",
              alt: "Panel with the Indian Ice Hockey Team at the Under Armour press conference",
            },
            {
              src: "/projects/ua-press-2.webp",
              alt: "Media audience watching the panel at the Under Armour press conference",
            },
            {
              src: "/projects/ua-press-3.webp",
              alt: "Ice Hockey Association of India announcement on the main screen at the Under Armour press conference",
            },
            {
              src: "/projects/ua-press-4.webp",
              alt: "The Under Armour press conference stage set up in the Ambience Mall atrium",
            },
            {
              src: "/projects/ua-press-5.webp",
              alt: "The Indian Ice Hockey Team with Under Armour leadership at the press conference",
            },
          ],
        },
      },
    ],
  },
  {
    slug: "government-events-summits",
    label: "Government Events & Summits",
    tagline: "Statecraft at scale — considered, disciplined, unforgettable.",
    lede:
      "From state investor summits to inter-governmental congresses, we deliver stagecraft, protocol and cinematic production for the most demanding audiences.",
    coverImage:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_work-portfolio-239/artifacts/gdd6qo0g_Government%20Events%20%26%20Summits.jpg",
    longMeta: true,
    events: [
      {
        id: "make-in-odisha-conclave",
        logo: "/projects/odisha-conclave-logo.png",
        logoAlt: "Make in Odisha Conclave logo",
        logoClass: "h-[2.562rem] md:h-[3.124rem]",
        title: "Flagship Biennial Global Investors Meet",
        meta: "A global investment meet connecting international delegates, investors and business leaders",
        image: {
          src: "/projects/odisha-event.webp",
          alt: "Geodesic dome projection mapping with temple artwork and light beams at night",
        },
        copy: "The event welcomed up to 31,000 visitors and saw participation from 6 countries: Japan, China, Italy, Germany, Saudi Arabia and South Korea. The evening was enhanced with a striking projection mapping experience on a geodesic dome.",
        detail: {
          brand: "Make in Odisha Conclave",
          name: "Make in Odisha Conclave",
          subtitle: "Flagship Biennial Global Investors Meet",
          description: "A global investment meet connecting international delegates, investors and business leaders",
          gallery: [
            {
              src: "/projects/odisha-1.webp",
              alt: "Kalinga Gate installation with Join the Juggernaut sign at the Make in Odisha Conclave",
            },
            {
              src: "/projects/odisha-2.webp",
              alt: "Multilingual Welcome wall at the Make in Odisha Conclave venue",
            },
            {
              src: "/projects/odisha-3.webp",
              alt: "Keynote address at the Make in Odisha Conclave plenary",
            },
            {
              src: "/projects/odisha-4.webp",
              alt: "Chief Minister Naveen Patnaik with industry leaders at the Make in Odisha Conclave",
            },
            {
              src: "/projects/odisha-5.webp",
              alt: "Wide view of the plenary hall at the Make in Odisha Conclave",
            },
            {
              src: "/projects/odisha-6.webp",
              alt: "Bibhu Mohapatra fashion showcase at the Make in Odisha Conclave evening",
            },
            {
              src: "/projects/odisha-7.webp",
              alt: "Skill Development projection on the geodesic dome at the Make in Odisha Conclave",
            },
          ],
        },
      },
      {
        id: "advantage-assam",
        logo: "/projects/advantage-assam-logo.png",
        logoAlt: "Advantage Assam logo",
        logoClass: "h-[4.045rem] md:h-[4.933rem]",
        title: "Advantage Assam",
        meta: "A landmark investment summit positioning Assam as a leading destination for domestic and international investment",
        image: {
          src: "/projects/assam-event.webp",
          alt: "Advantage Assam installation at Indira Gandhi Athletic Stadium with floral forecourt",
        },
        copy: "The event brought together over 3,500 domestic and international investors, with MoUs worth ₹1 lakh crore signed for investment in Assam. Spanning 10 focus sectors, the exhibition saw participation from 7 state departments across 48,000 sq. ft. of exhibition space, supported by 2 lakh sq. ft. of covered-hanger infrastructure and 4 lakh sq. ft. of venue branding and custom installations.",
        detail: {
          brand: "Advantage Assam",
          name: "Advantage Assam",
          subtitle: "Advantage Assam",
          description: "A landmark investment summit positioning Assam as a leading destination for domestic and international investment",
          gallery: [
            {
              src: "/projects/assam-1.webp",
              alt: "Advantage Assam installation at Indira Gandhi Athletic Stadium with floral forecourt",
            },
            {
              src: "/projects/assam-2.webp",
              alt: "Illuminated Advantage Assam pyramid installation at night",
            },
            {
              src: "/projects/assam-3.webp",
              alt: "Red and blue carpeted welcome hall at Advantage Assam",
            },
            {
              src: "/projects/assam-4.webp",
              alt: "Inauguration ceremony with the traditional xorai lamp at Advantage Assam",
            },
            {
              src: "/projects/assam-5.webp",
              alt: "The plenary hall stage at Advantage Assam",
            },
          ],
        },
      },
      {
        id: "invest-mp-gis-2016",
        logo: "/projects/invest-mp-logo.png",
        logoAlt: "Invest Madhya Pradesh — Global Investors Summit logo",
        logoClass: "h-[3.009rem] md:h-[3.669rem]",
        title: "Global Investors Summit",
        meta: "180 Speakers · 7000 Business Delegates · 13 Thematic Sessions · 42 Participating Countries",
        image: {
          src: "/projects/invest-mp-5.webp",
          alt: "Keynote address at the Global Investors Summit — Invest Madhya Pradesh",
        },
        copy: "Delivered across five editions from 2015 to 2019, the summit brought together global investors, policymakers and industry leaders through international sessions, sector discussions and business networking. By 2019, it featured 36 participating countries, 1,200 business-to-business meetings and investment intentions worth ₹2.84 trillion.",
        detail: {
          brand: "Global Investors Summit",
          name: "Global Investors Summit",
          subtitle: "Global Investors Summit",
          description:
            "180 Speakers · 7000 Business Delegates · 13 Thematic Sessions · 42 Participating Countries",
          gallery: [
            {
              src: "/projects/invest-mp-1.webp",
              alt: "Welcome LED screen and stage set-up at the Global Investors Summit 2016, Indore",
            },
            {
              src: "/projects/invest-mp-2.webp",
              alt: "Dignitaries and global leaders group photograph at the Global Investors Summit",
            },
            {
              src: "/projects/invest-mp-3.webp",
              alt: "Seated leadership panel at the Invest Madhya Pradesh summit",
            },
            {
              src: "/projects/invest-mp-4.webp",
              alt: "Plenary hall wide view with audience and LED screens at the Global Investors Summit 2016",
            },
            {
              src: "/projects/invest-mp-5.webp",
              alt: "Keynote address at the Global Investors Summit — Invest Madhya Pradesh",
            },
          ],
        },
      },
      {
        id: "bengal-global-business-summit",
        logo: "/projects/bengal-global-logo.png",
        logoAlt: "Bengal Global Business Summit — Biswa Bangla logo",
        logoClass: "h-[4.92rem] md:h-[6.0rem]",
        detailLogoClass: "h-[8.04rem] md:h-[9.81rem]",
        title: "Bengal Global Business Summit",
        meta: "2015",
        image: {
          src: "/projects/bengal-2015-hero.webp",
          alt: "Bengal Global Business Summit 2015 venue entrance with Biswa Bangla branding",
        },
        copy: "The inaugural Bengal Global Business Summit brought together 20 participating countries, 40+ speakers and 1,200+ business delegates for a global platform focused on investment, entrepreneurship and emerging opportunities. The summit featured plenary sessions on start-ups and entrepreneurship, international and multi-country interactions, sector-focused sessions and dedicated country sessions. Roundtable discussions explored Bengal\u2019s growing role in emerging Asia, alongside conversations around the apparel and allied sectors.",
        detail: {
          brand: "Bengal Global Business Summit",
          name: "Bengal Global Business Summit",
          subtitle: "Bengal Global Business Summit",
          description: "2015",
          gallery: [
            {
              src: "/projects/bengal-2015-1.webp",
              alt: "Pavilion lane at the Bengal Global Business Summit 2015 venue",
            },
            {
              src: "/projects/bengal-2015-2.webp",
              alt: "Bengal Global Business Summit 2015 venue entrance with Biswa Bangla branding",
            },
            {
              src: "/projects/bengal-2015-3.webp",
              alt: "International business delegates at the Bengal Global Business Summit 2015",
            },
            {
              src: "/projects/bengal-2015-4.webp",
              alt: "Inaugural plenary of the Bengal Global Business Summit 2015 with leadership on stage",
            },
            {
              src: "/projects/bengal-2015-5.webp",
              alt: "Evening gala stage at the Bengal Global Business Summit 2015",
            },
          ],
        },
      },
      {
        id: "bengal-global-business-summit-b",
        logo: "/projects/bengal-global-logo.png",
        logoAlt: "Bengal Global Business Summit — Biswa Bangla logo",
        logoClass: "h-[4.92rem] md:h-[6.0rem]",
        detailLogoClass: "h-[8.04rem] md:h-[9.81rem]",
        title: "Bengal Global Business Summit",
        meta: "2016",
        image: {
          src: "/projects/bengal-2016-2.webp",
          alt: "Come to Bengal Ride the Growth installation at the Bengal Global Business Summit 2016",
        },
        copy: "The 2016 edition of the Bengal Global Business Summit brought together 26 participating countries, 45+ speakers and 1,500+ business delegates, building on the summit\u2019s growing global platform. The event brought together business and government leaders for conversations, collaborations and opportunities focused on strengthening Bengal\u2019s position as a destination for global business and investment.",
        detail: {
          brand: "Bengal Global Business Summit",
          name: "Bengal Global Business Summit",
          subtitle: "Bengal Global Business Summit",
          description: "2016",
          gallery: [
            {
              src: "/projects/bengal-2016-1.webp",
              alt: "Delegates walking through the Bengal Global Business Summit 2016 venue",
            },
            {
              src: "/projects/bengal-2016-2.webp",
              alt: "Come to Bengal Ride the Growth installation at the Bengal Global Business Summit 2016",
            },
            {
              src: "/projects/bengal-2016-3.webp",
              alt: "Design Hub pavilion at the Bengal Global Business Summit 2016",
            },
            {
              src: "/projects/bengal-2016-4.webp",
              alt: "Chief Minister addressing the plenary at the Bengal Global Business Summit 2016",
            },
            {
              src: "/projects/bengal-2016-5.webp",
              alt: "Plenary session with partner country Japan at the Bengal Global Business Summit 2016",
            },
          ],
        },
      },
      {
        id: "bengal-global-business-summit-c",
        logo: "/projects/bengal-global-logo.png",
        logoAlt: "Bengal Global Business Summit — Biswa Bangla logo",
        logoClass: "h-[4.92rem] md:h-[6.0rem]",
        detailLogoClass: "h-[8.04rem] md:h-[9.81rem]",
        title: "Bengal Global Business Summit",
        meta: "2017",
        image: {
          src: "/projects/bengal-2017-6.webp",
          alt: "The illuminated Biswa Bangla dome at night during the Bengal Global Business Summit 2017",
        },
        copy: "The 2017 edition of the Bengal Global Business Summit continued its growth as a global platform for business, investment and collaboration, bringing together 29 participating countries, 50+ speakers and 2,000+ business delegates. Built around the theme \u201cCome to Bengal, Ride the Growth,\u201d the summit created a dynamic environment for industry leaders, investors and policymakers to connect, exchange ideas and explore opportunities across Bengal\u2019s growing business landscape.",
        detail: {
          brand: "Bengal Global Business Summit",
          name: "Bengal Global Business Summit",
          subtitle: "Bengal Global Business Summit",
          description: "2017",
          gallery: [
            {
              src: "/projects/bengal-2017-1.webp",
              alt: "Traditional drummers welcoming delegates at the Bengal Global Business Summit 2017",
            },
            {
              src: "/projects/bengal-2017-2.webp",
              alt: "Chief Minister Mamata Banerjee walking with delegates at the Bengal Global Business Summit 2017",
            },
            {
              src: "/projects/bengal-2017-3.webp",
              alt: "Bengal Beckons plenary stage with Biswa Bangla screens at the Bengal Global Business Summit 2017",
            },
            {
              src: "/projects/bengal-2017-4.webp",
              alt: "Thousands of business delegates in the main hangar at the Bengal Global Business Summit 2017",
            },
            {
              src: "/projects/bengal-2017-5.webp",
              alt: "Lamp-lighting ceremony at the inaugural of the Bengal Global Business Summit 2017",
            },
            {
              src: "/projects/bengal-2017-6.webp",
              alt: "The illuminated Biswa Bangla dome at night during the Bengal Global Business Summit 2017",
            },
          ],
        },
      },
      {
        id: "bengal-global-business-summit-d",
        logo: "/projects/bengal-global-logo.png",
        logoAlt: "Bengal Global Business Summit — Biswa Bangla logo",
        logoClass: "h-[4.92rem] md:h-[6.0rem]",
        detailLogoClass: "h-[8.04rem] md:h-[9.81rem]",
        title: "Bengal Global Business Summit",
        meta: "2018",
        image: {
          src: "/projects/bengal-event.webp",
          alt: "Bengal Global Business Summit plenary — wide stage with leadership and big screens",
        },
        copy: "The 2018 summit brought together 32 participating countries, including 8 partner countries, with 18 sessions, including 11 parallel sectoral sessions. The programme featured plenary sessions on start-ups and entrepreneurship, international multi-country interactions, focus-sector and country sessions, and roundtable discussions on Bengal\u2019s rise in emerging Asia, alongside the apparel and allied sectors.",
        detail: {
          brand: "Bengal Global Business Summit",
          name: "Bengal Global Business Summit",
          subtitle: "Bengal Global Business Summit",
          description: "2018",
          gallery: [
            {
              src: "/projects/bengal-2018-1.webp",
              alt: "Partner countries wall and Hall of Nations at the Bengal Global Business Summit 2018",
            },
            {
              src: "/projects/bengal-2018-2.webp",
              alt: "Aerial night view of the illuminated Bengal Global Business Summit 2018 venue",
            },
            {
              src: "/projects/bengal-2018-3.webp",
              alt: "Global business leaders with the Chief Minister on stage at the Bengal Global Business Summit 2018",
            },
            {
              src: "/projects/bengal-2018-4.webp",
              alt: "Chief Minister addressing the plenary at the Bengal Global Business Summit 2018",
            },
            {
              src: "/projects/bengal-2018-5.webp",
              alt: "Industry leaders seated at the plenary of the Bengal Global Business Summit 2018",
            },
          ],
        },
      },
      {
        id: "bengal-global-business-summit-e",
        logo: "/projects/bengal-global-logo.png",
        logoAlt: "Bengal Global Business Summit — Biswa Bangla logo",
        logoClass: "h-[4.92rem] md:h-[6.0rem]",
        detailLogoClass: "h-[8.04rem] md:h-[9.81rem]",
        title: "Bengal Global Business Summit",
        meta: "2019",
        image: {
          src: "/projects/bengal-2019-3.webp",
          alt: "Global business leaders with the Chief Minister at the Bengal Global Business Summit 2019",
        },
        copy: "The 2019 edition brought together 36 participating countries and facilitated 1,200 business-to-business meetings, creating a strong platform for global investment and collaboration. The summit generated investment intentions worth \u20b92.84 trillion, reinforcing Bengal\u2019s growing position as a destination for business and investment.",
        detail: {
          brand: "Bengal Global Business Summit",
          name: "Bengal Global Business Summit",
          subtitle: "Bengal Global Business Summit",
          description: "2019",
          gallery: [
            {
              src: "/projects/bengal-2019-1.webp",
              alt: "Aerial view of the Bengal Global Business Summit 2019 venue with the #BengalMeansBusiness pyramid",
            },
            {
              src: "/projects/bengal-2019-2.webp",
              alt: "The #BengalMeansBusiness auditorium stage at the Bengal Global Business Summit 2019",
            },
            {
              src: "/projects/bengal-2019-3.webp",
              alt: "Global business leaders with the Chief Minister at the Bengal Global Business Summit 2019",
            },
            {
              src: "/projects/bengal-2019-4.webp",
              alt: "The Chief Minister addressing a packed auditorium at the Bengal Global Business Summit 2019",
            },
            {
              src: "/projects/bengal-2019-5.webp",
              alt: "Cultural performance at the Bengal Global Business Summit 2019 evening gala",
            },
          ],
        },
      },
      {
        id: "kiff-2016",
        logo: "/projects/kiff-logo.png",
        logoAlt: "22nd Kolkata International Film Festival logo",
        logoClass: "h-[4.098rem] md:h-[4.998rem]",
        title: "Kolkata International Film Festival",
        meta: "A landmark film festival bringing together cinema, culture and some of India's biggest names in entertainment",
        image: {
          src: "/projects/kiff-event.webp",
          alt: "Amitabh Bachchan, Shah Rukh Khan and Parineeti Chopra at the KIFF podium",
        },
        copy: "The 22nd Kolkata International Film Festival was held in November 2016, attracting 20,000 attendees and bringing together leading filmmakers, artists and Bollywood personalities. The festival featured Amitabh Bachchan, Jaya Bachchan, Abhishek Bachchan, Aishwarya Rai Bachchan, Sanjay Dutt, Shah Rukh Khan, Kajol and Parineeti Chopra, and was organised by the West Bengal Film Centre under the state government.",
        detail: {
          brand: "Kolkata International Film Festival",
          name: "Kolkata International Film Festival",
          subtitle: "Kolkata International Film Festival",
          description:
            "A landmark film festival bringing together cinema, culture and some of India's biggest names in entertainment",
          gallery: [
            {
              src: "/projects/kiff-1.webp",
              alt: "Lamp-lighting ceremony with Mamata Banerjee, Shah Rukh Khan, Kajol and Parineeti Chopra at KIFF 2016",
            },
            {
              src: "/projects/kiff-2.webp",
              alt: "Amitabh Bachchan, Shah Rukh Khan and Parineeti Chopra addressing the audience from the 22nd KIFF podium",
            },
            {
              src: "/projects/kiff-3.webp",
              alt: "Main stage with 22nd KIFF branding and live screens at the Kolkata International Film Festival 2016",
            },
          ],
        },
      },
      {
        id: "indian-urban-housing-conclave-2022",
        logo: "/projects/iuhc-logo.png",
        logoAlt: "Indian Urban Housing Conclave 2022 logo",
        logoClass: "h-[3.382rem] md:h-[4.125rem]",
        title: "AMRUT 2.0 Pavilion",
        meta: "Rajkot, Gujarat | Indian Urban Conclave",
        image: {
          src: "/projects/amrut-hero.webp",
          alt: "AMRUT 2.0 pavilion wall with India water map and mission statistics at the Indian Urban Conclave",
        },
        copy: "The AMRUT 2.0 Pavilion at the Indian Urban Conclave 2022 showcased the mission’s vision for strengthening water infrastructure and building resilient Indian cities. Across three government pavilions, the experience highlighted initiatives spanning water supply, sewerage and urban transformation, creating an engaging walkthrough that helped visitors understand the programme’s scale and impact.",
        detail: {
          brand: "AMRUT 2.0 Pavilion",
          name: "AMRUT 2.0 Pavilion",
          subtitle: "AMRUT 2.0 Pavilion",
          description: "Rajkot, Gujarat | Indian Urban Conclave",
          gallery: [
            {
              src: "/projects/amrut-1.webp",
              alt: "AMRUT 2.0 pavilion exterior with mission header and walkthrough bays",
            },
            {
              src: "/projects/amrut-2.webp",
              alt: "AMRUT 2.0 pavilion wall with India water map and mission statistics at the Indian Urban Conclave",
            },
            {
              src: "/projects/amrut-3.webp",
              alt: "AMRUT Liberating Women and Atal Mission achievements wall with display models",
            },
            {
              src: "/projects/amrut-4.webp",
              alt: "Landmark Reforms, Startups and Pey Jal Survekshan 2022 infographic walls",
            },
            {
              src: "/projects/amrut-5.webp",
              alt: "Pavilion walkthrough with the AMRUT Liberating Women media wall and city models",
            },
          ],
        },
      },
      {
        id: "indian-urban-housing-conclave-2022-b",
        logo: "/projects/iuhc-logo.png",
        logoAlt: "Indian Urban Housing Conclave 2022 logo",
        logoClass: "h-[3.382rem] md:h-[4.125rem]",
        title: "Smart Cities Mission Pavilion",
        meta: "Rajkot, Gujarat | Indian Urban Conclave",
        image: {
          src: "/projects/smartcities-hero.webp",
          alt: "Smart Cities Mission pavilion with circular header and Successful PPP Projects showcase wall",
        },
        copy: "The Smart Cities Mission Pavilion showcased India’s progress in building technology-enabled, sustainable and citizen-centric cities. Through interactive displays, case studies and visual storytelling, the pavilion highlighted smart infrastructure, digital governance and urban innovation, creating an immersive experience that demonstrated how the mission is reshaping India’s urban landscape.",
        detail: {
          brand: "Smart Cities Mission Pavilion",
          name: "Smart Cities Mission Pavilion",
          subtitle: "Smart Cities Mission Pavilion",
          description: "Rajkot, Gujarat | Indian Urban Conclave",
          gallery: [
            {
              src: "/projects/smartcities-1.webp",
              alt: "Smart Cities Mission pavilion exterior with circular windows and the PM's quote centerpiece",
            },
            {
              src: "/projects/smartcities-2.webp",
              alt: "Smart Cities Mission pavilion with circular header and Successful PPP Projects showcase wall",
            },
            {
              src: "/projects/smartcities-3.webp",
              alt: "Integrated Command and Control Centres wall with ICCC functions display",
            },
            {
              src: "/projects/smartcities-4.webp",
              alt: "Project circles wall with Social Infrastructure, Smart Energy and WASH statistics over the Bhopal Smart City model",
            },
            {
              src: "/projects/smartcities-5.webp",
              alt: "Visitors exploring the Smart Cities Mission pavilion from the lawn seating area",
            },
          ],
        },
      },
      {
        id: "indian-urban-housing-conclave-2022-c",
        logo: "/projects/iuhc-logo.png",
        logoAlt: "Indian Urban Housing Conclave 2022 logo",
        logoClass: "h-[3.382rem] md:h-[4.125rem]",
        title: "Urban Mobility Pavilion",
        meta: "Rajkot, Gujarat | Indian Urban Conclave",
        image: {
          src: "/projects/urbanmobility-hero.webp",
          alt: "Urban Transport branded pillar at the Urban Mobility Pavilion entrance",
        },
        copy: "The Urban Mobility Pavilion showcased the evolution of transport infrastructure and sustainable mobility across Indian cities. Through immersive graphics, models and multimedia, the pavilion highlighted BRTS, metro systems and integrated public transport, offering visitors a clear perspective on the future of connected, infrastructure-driven urban mobility.",
        detail: {
          brand: "Urban Mobility Pavilion",
          name: "Urban Mobility Pavilion",
          subtitle: "Urban Mobility Pavilion",
          description: "Rajkot, Gujarat | Indian Urban Conclave",
          gallery: [
            {
              src: "/projects/urbanmobility-1.webp",
              alt: "Urban Mobility Pavilion exterior with the Urban Transport pillar and blue accent lighting",
            },
            {
              src: "/projects/urbanmobility-2.webp",
              alt: "BRTS and Urban Mobility wall with city statistics and network photography",
            },
            {
              src: "/projects/urbanmobility-3.webp",
              alt: "Urban Transport Division wall covering metro rail progress and technological reforms",
            },
            {
              src: "/projects/urbanmobility-4.webp",
              alt: "AatmaNirbhar Bharat Make in India wall with rolling stock displays and OEM partner logos",
            },
          ],
        },
      },
    ],
  },
  {
    slug: "sports-events-activations",
    label: "Sports Events & Activations",
    tagline: "Where fandom becomes memory.",
    lede:
      "League activations, fan-zones, launches and team experiences that give brands a real seat inside the culture of sport.",
    coverImage:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_work-portfolio-239/artifacts/jxesqf1n_Sports%20Events%20%26%20Activations.webp",
    longMeta: true,
    events: [
      {
        id: "intellion-futsal-league",
        logo: "/projects/futsal-logo.png",
        logoAlt: "Intellion Futsal League by Tata Realty logo",
        logoClass: "h-[3.204rem] md:h-[3.907rem]",
        title: "Intellion Futsal League",
        meta: "Season 1 | Gurgaon",
        image: {
          src: "/projects/ifl-hero.webp",
          alt: "Intellion Futsal League Season 1 champions on the podium with the trophy",
        },
        copy: "The inaugural season of the Intellion Futsal League launched in Gurgaon with 8 corporate teams, establishing the foundation for a multi-city sporting property. The opening ceremony featured freestyle footballer Archie Patel, setting an energetic tone for the league and creating early engagement around the new sporting platform.",
        detail: {
          brand: "Intellion Futsal League",
          name: "Intellion Futsal League",
          subtitle: "Intellion Futsal League",
          description: "Season 1 | Gurgaon",
          gallery: [
            {
              src: "/projects/ifl-1.webp",
              alt: "WELCOME entry gate with giant football at the Intellion Futsal League, Gurugram",
            },
            {
              src: "/projects/ifl-2.webp",
              alt: "Intellion Futsal League player banners lining the arena walkway",
            },
            {
              src: "/projects/ifl-3.webp",
              alt: "Aerial view of the branded Intellion Futsal League arena with floodlights",
            },
            {
              src: "/projects/ifl-4.webp",
              alt: "All eight corporate teams lined up on court at the Intellion Futsal League opener",
            },
            {
              src: "/projects/ifl-5.webp",
              alt: "Intellion Futsal League trophies — Winners, Runner-Up and Player of the Tournament",
            },
            {
              src: "/projects/ifl-6.webp",
              alt: "Freestyle footballer performing with cheerleaders at the Intellion Futsal League opening night",
            },
            {
              src: "/projects/ifl-7.webp",
              alt: "Season 1 champions celebrating with the trophy on the CHAMPIONS podium",
            },
          ],
        },
      },
      {
        id: "intellion-futsal-league-b",
        logo: "/projects/futsal-2-logo.png",
        logoAlt: "Intellion Futsal League 2.0 logo",
        logoClass: "h-[2.986rem] md:h-[3.641rem]",
        title: "Intellion Futsal League 2.0",
        meta: "Season 2 | Gurgaon & Chennai",
        image: {
          src: "/projects/ifl2-hero.webp",
          alt: "Intellion Futsal League 2.0 football sculpture installation with branded plinth and banners",
        },
        copy: "Season 2 expanded the Intellion Futsal League into Chennai, growing participation to 12 teams in Gurgaon and 42 teams in Chennai. The league strengthened its cultural identity with custom city anthems, live rap battles and choreographed opening performances, while introducing multi-camera live broadcasts, commentary and real-time scoring to elevate audience engagement both on-ground and online.",
        detail: {
          brand: "Intellion Futsal League 2.0",
          name: "Intellion Futsal League 2.0",
          subtitle: "Intellion Futsal League 2.0",
          description: "Season 2 | Gurgaon & Chennai",
          gallery: [
            {
              src: "/projects/ifl2-1.webp",
              alt: "Intellion Futsal League 2.0 football sculpture installation with branded plinth and banners",
            },
            {
              src: "/projects/ifl2-2.webp",
              alt: "Night match under floodlights viewed from packed stands — Intellion Futsal League Season 2",
            },
            {
              src: "/projects/ifl2-3.webp",
              alt: "Choreographed opening performance with cheerleaders and live rap at the Season 2 opener",
            },
            {
              src: "/projects/ifl2-4.webp",
              alt: "TRIL leadership with the Intellion Futsal League 2.0 trophy on the branded podium",
            },
            {
              src: "/projects/ifl2-5.webp",
              alt: "Season 2 league match in progress at the Intellion Futsal arena",
            },
            {
              src: "/projects/ifl2-6.webp",
              alt: "Season 2 champions in orange lifting the trophy under the CHAMPIONS arch",
            },
            {
              src: "/projects/ifl2-7.webp",
              alt: "Intellion Futsal League 2.0 Gurugram 2023 champions celebrating with medals and confetti",
            },
            {
              src: "/projects/ifl2-8.webp",
              alt: "Match action — player striking the ball between defenders at Season 2",
            },
          ],
        },
      },
      {
        id: "intellion-futsal-league-c",
        logo: "/projects/futsal-4-logo.png",
        logoAlt: "Intellion Futsal League IV logo",
        logoClass: "h-[2.829rem] md:h-[3.45rem]",
        title: "Intellion Futsal League IV",
        meta: "Season 4 | Chennai",
        image: {
          src: "/projects/ifl4-hero.webp",
          alt: "Women's league match under floodlights — AstraZeneca player on the ball at Intellion Futsal League IV",
        },
        copy: "Season 4 marked a defining chapter for the Intellion Futsal League, with 62 teams participating in Chennai. The season introduced a distinctive identity system featuring Leo the mascot, a custom-designed trophy, team crests and a championship star system. With the introduction of women’s teams, the league expanded participation and inclusivity, evolving into a recognizable sporting property built on continuity, identity and legacy.",
        detail: {
          brand: "Intellion Futsal League IV",
          name: "Intellion Futsal League IV",
          subtitle: "Intellion Futsal League IV",
          description: "Season 4 | Chennai",
          gallery: [
            {
              src: "/projects/ifl4-1.webp",
              alt: "TRIL leadership unveiling the Intellion Futsal League IV trophy on its branded podium",
            },
            {
              src: "/projects/ifl4-2.webp",
              alt: "Leo the mascot with cheerleaders and confetti at the Season 4 opening ceremony",
            },
            {
              src: "/projects/ifl4-3.webp",
              alt: "Intellion Futsal League IV trophy display with championship and individual awards",
            },
            {
              src: "/projects/ifl4-4.webp",
              alt: "Season 4 league match in progress — player striking the ball at the Intellion arena",
            },
            {
              src: "/projects/ifl4-5.webp",
              alt: "Women's league match under floodlights at Intellion Futsal League IV",
            },
            {
              src: "/projects/ifl4-6.webp",
              alt: "Champions 2025 — winning team jumping in celebration on the podium",
            },
            {
              src: "/projects/ifl4-7.webp",
              alt: "Women's champions lifting the trophy amid pyros at the Champions 2025 ceremony",
            },
          ],
        },
      },
      {
        id: "intellion-futsal-league-d",
        logo: "/projects/futsal-5-logo.png",
        logoAlt: "Intellion Futsal League V by Tata Realty logo",
        logoClass: "h-[3.2rem] md:h-[3.902rem]",
        title: "Intellion Futsal League V",
        meta: "Season 5 | Gurgaon & Chennai",
        image: {
          src: "/projects/ifl5-hero.webp",
          alt: "Dunnhumby team celebrating with Leo the mascot at Intellion Futsal League V",
        },
        copy: "Season 5 brought the Intellion Futsal League back to Gurgaon and Chennai at its grandest scale yet. The season paired spectacle with purpose — a glittering trophy unveiling with drummers, cheerleaders and confetti, Leo the mascot engaging fans and communities, and the “Play for Good” initiative extending the league’s impact beyond the pitch. Five seasons in, the property completed its evolution from a corporate tournament into a sporting tradition played for a larger cause.",
        detail: {
          brand: "Intellion Futsal League V",
          name: "Intellion Futsal League V",
          subtitle: "Intellion Futsal League V",
          description: "Season 5 | Gurgaon & Chennai",
          gallery: [
            {
              src: "/projects/ifl5-1.webp",
              alt: "Cheerleaders and drummers opening Intellion Futsal League V as the trophy waits veiled on its plinth",
            },
            {
              src: "/projects/ifl5-2.webp",
              alt: "Season 5 finale celebration — performers, cheerleaders and the unveiled trophy amid confetti and pyros",
            },
            {
              src: "/projects/ifl5-3.webp",
              alt: "TRIL leadership unveiling the Intellion Futsal League V trophy under a shower of golden confetti",
            },
            {
              src: "/projects/ifl5-4.webp",
              alt: "Leo the mascot guarding goal as a young fan takes a penalty at the Season 5 fan engagement zone",
            },
            {
              src: "/projects/ifl5-5.webp",
              alt: "Season 5 league match — IBM and Tata Digital players contesting the ball by the branded boards",
            },
            {
              src: "/projects/ifl5-6.webp",
              alt: "Orange-kit player driving forward with the ball in a Season 5 day match",
            },
            {
              src: "/projects/ifl5-7.webp",
              alt: "Dunnhumby team celebrating with Leo the mascot at Intellion Futsal League V",
            },
            {
              src: "/projects/ifl5-8.webp",
              alt: "Women's winner with her medal and the golden trophy on a confetti-strewn pitch, Chennai 2026",
            },
            {
              src: "/projects/ifl5-9.webp",
              alt: "Champions 2026 — women's title winners on the podium with medals and pyros",
            },
          ],
        },
      },
      {
        id: "mission-eleven-million",
        logo: "/projects/mxim-logo.png",
        logoAlt: "MXIM — Mission Eleven Million logo",
        logoClass: "h-[4.042rem] md:h-[4.929rem]",
        title: "Mission Eleven Million",
        meta: "32 Cities | 9 Months | Grassroots Football Initiative",
        image: {
          src: "/projects/mxim-hero.webp",
          alt: "Football handover at the MXIM Mission Eleven Million branded backdrop",
        },
        copy: "Mission Eleven Million was a nationwide grassroots football initiative spanning 32 cities over 9 months, using football to engage and inspire young athletes. The programme conducted 174 seminars and workshops with school principals and teachers, alongside 80 football carnivals that introduced children to the sport and helped build football skills at the grassroots level.",
        detail: {
          brand: "Mission Eleven Million",
          name: "Mission Eleven Million",
          subtitle: "Mission Eleven Million",
          description: "32 Cities | 9 Months | Grassroots Football Initiative",
          gallery: [
            {
              src: "/projects/mxim-1.webp",
              alt: "Welcome to Mission Eleven Million Festival — branded entry gate at the stadium, Delhi 2017",
            },
            {
              src: "/projects/mxim-2.webp",
              alt: "Stadium pitch dressed with FIFA U-17 World Cup India 2017 and MXIM A-frame boards",
            },
            {
              src: "/projects/mxim-3.webp",
              alt: "Children cheering from the stands at a Mission Eleven Million football carnival",
            },
            {
              src: "/projects/mxim-4.webp",
              alt: "Young trainee practising ball control at a Mission Eleven Million coaching session",
            },
            {
              src: "/projects/mxim-5.webp",
              alt: "Football handover at the MXIM Mission Eleven Million branded backdrop",
            },
          ],
        },
      },
      {
        id: "vivo-pro-kabaddi-mall-activation",
        logo: "/projects/vivo-prokabaddi-logo.png",
        logoAlt: "VIVO Pro Kabaddi logo",
        logoClass: "h-[3.985rem] md:h-[4.86rem]",
        title: "VIVO Pro Kabaddi | Mall Activation",
        meta: "Mall Activation | 10 Cities | 7,000+ Participants",
        image: {
          src: "/projects/kabaddi-hero.webp",
          alt: "Winners celebrating with a vivo Pro Kabaddi branded umbrella on the pink activation court",
        },
        copy: "vivo Pro Kabaddi brought the sport closer to audiences through a three-month mall activation across 10 cities. The experience used interactive gamification to give audiences an engaging taste of kabaddi, driving participation and creating a strong connection with the sport across diverse audiences nationwide.",
        detail: {
          brand: "vivo Pro Kabaddi Mall Activation",
          name: "vivo Pro Kabaddi Mall Activation",
          subtitle: "vivo Pro Kabaddi Mall Activation",
          description: "Mall Activation | 10 Cities | 7,000+ Participants",
          gallery: [
            {
              src: "/projects/kabaddi-1.webp",
              alt: "Full vivo Pro Kabaddi mall booth with pink and blue kabaddi court, Gachibowli Stadium branding",
            },
            {
              src: "/projects/kabaddi-2.webp",
              alt: "Crowd at the vivo Pro Kabaddi mall activation entrance under hotstar-branded trussing",
            },
            {
              src: "/projects/kabaddi-3.webp",
              alt: "Aerial view of the vivo Pro Kabaddi mall activation booth drawing shoppers",
            },
            {
              src: "/projects/kabaddi-4.webp",
              alt: "Tug-of-war game in front of the #LePanga Star Sports LED wall at the activation",
            },
            {
              src: "/projects/kabaddi-5.webp",
              alt: "Winners celebrating with a vivo Pro Kabaddi branded umbrella on the pink activation court",
            },
          ],
        },
      },
      {
        id: "icc-cwc-trophy-tour",
        logo: "/projects/icc-logo.png",
        logoAlt: "ICC — International Cricket Council logo",
        logoClass: "h-[3.069rem] md:h-[3.743rem]",
        title: "ICC Cricket World Cup Trophy Tour",
        meta: "2018 | India | 4 Cities | 100,000+ Eyeballs",
        image: {
          src: "/projects/cwc-hero.webp",
          alt: "Aerial view of the giant ICC World Cup trophy card mosaic formed by participants on a field",
        },
        copy: "The ICC Cricket World Cup Trophy Tour brought the World Cup experience closer to fans across 4 Indian cities. The tour created high-impact public and community engagements, with cricket icons VVS Laxman and Unmukt Chand adding to the experience and helping generate over 100,000 eyeballs across the activation.",
        detail: {
          brand: "ICC Cricket World Cup Trophy Tour",
          name: "ICC Cricket World Cup Trophy Tour",
          subtitle: "ICC Cricket World Cup Trophy Tour",
          description: "2018 | India | 4 Cities | 100,000+ Eyeballs",
          gallery: [
            {
              src: "/projects/cwc-1.webp",
              alt: "ICC Cricket World Cup Trophy Tour mall activation with Nissan Kicks car and branded backdrop",
            },
            {
              src: "/projects/cwc-2.webp",
              alt: "Trophy Tour experience zone with cricket stumps game and live leaderboard screen",
            },
            {
              src: "/projects/cwc-3.webp",
              alt: "Aerial view of crowds gathered around the Trophy Tour activation in the mall atrium",
            },
            {
              src: "/projects/cwc-4.webp",
              alt: "Aerial view of the giant ICC World Cup trophy card mosaic formed by participants on a field",
            },
            {
              src: "/projects/cwc-5.webp",
              alt: "Close aerial of the World Cup trophy mosaic with participants forming the design",
            },
          ],
        },
      },
      {
        id: "icc-cwc-trophy-tour-b",
        logo: "/projects/icc-logo.png",
        logoAlt: "ICC — International Cricket Council logo",
        logoClass: "h-[3.069rem] md:h-[3.743rem]",
        title: "ICC Cricket World Cup Trophy Tour",
        meta: "2018 | Sri Lanka | 2 Colleges | 7,500+ Eyeballs",
        image: {
          src: "/projects/cwc-sl-hero.webp",
          alt: "Sri Lanka leg — team with elephants and the #CWCTrophyTour plinth",
        },
        copy: "The Sri Lanka leg of the ICC Cricket World Cup Trophy Tour combined cricket, community engagement and unique local experiences. The activation reached 2,000 students across two colleges, featured a striking photo opportunity at Lion Rock and generated over 7,500 eyeballs throughout the day.",
        detail: {
          brand: "ICC Cricket World Cup Trophy Tour",
          name: "ICC Cricket World Cup Trophy Tour",
          subtitle: "ICC Cricket World Cup Trophy Tour",
          description: "2018 | Sri Lanka | 2 Colleges | 7,500+ Eyeballs",
          gallery: [
            {
              src: "/projects/cwc-sl-1.webp",
              alt: "ICC Cricket World Cup trophy on display with Nissan branding and stanchions",
            },
            {
              src: "/projects/cwc-sl-2.webp",
              alt: "Fans posing behind the giant #CWCTrophyTour letters inside the tour marquee",
            },
            {
              src: "/projects/cwc-sl-3.webp",
              alt: "Sri Lanka leg — team with elephants and the #CWCTrophyTour plinth",
            },
            {
              src: "/projects/cwc-sl-4.webp",
              alt: "College students gathered for the Trophy Tour photo outside the campus building",
            },
          ],
        },
      },
      {
        id: "icc-cwc-trophy-tour-c",
        logo: "/projects/icc-logo.png",
        logoAlt: "ICC — International Cricket Council logo",
        logoClass: "h-[3.069rem] md:h-[3.743rem]",
        title: "ICC Cricket World Cup Trophy Tour",
        meta: "2018 | Nepal | Community & Cricket Engagement",
        image: {
          src: "/projects/cwc-np-hero.webp",
          alt: "Miss Nepal 2018 Shrinkhala Khatiwada unveiling the ICC World Cup trophy at the showroom",
        },
        copy: "The Nepal leg of the ICC Cricket World Cup Trophy Tour created memorable community and cricket engagements across the country. Nepali cricketer Sandeep Lamichhane accompanied the trophy to Phewa Lake in Pokhara for a special shoot, while community activations at Pokhara Cricket Ground and Swayambhu Temple brought the World Cup experience closer to local audiences. Miss Nepal 2018, Shrinkhala Khatiwada, also unveiled the trophy at the showroom.",
        detail: {
          brand: "ICC Cricket World Cup Trophy Tour",
          name: "ICC Cricket World Cup Trophy Tour",
          subtitle: "ICC Cricket World Cup Trophy Tour",
          description: "2018 | Nepal | Community & Cricket Engagement",
          gallery: [
            {
              src: "/projects/cwc-np-1.webp",
              alt: "The ICC World Cup trophy against the illuminated Swayambhu stupa at dusk",
            },
            {
              src: "/projects/cwc-np-2.webp",
              alt: "Miss Nepal 2018 Shrinkhala Khatiwada unveiling the ICC World Cup trophy at the showroom",
            },
            {
              src: "/projects/cwc-np-3.webp",
              alt: "The trophy amid pigeons at the temples of Kathmandu's Durbar Square",
            },
            {
              src: "/projects/cwc-np-4.webp",
              alt: "Officials with the trophy and the Nepal flag at the temple unveiling",
            },
          ],
        },
      },
      {
        id: "icc-cwc-trophy-tour-d",
        logo: "/projects/icc-logo.png",
        logoAlt: "ICC — International Cricket Council logo",
        logoClass: "h-[3.069rem] md:h-[3.743rem]",
        title: "ICC Cricket World Cup Trophy Tour",
        meta: "2018 | Bangladesh | Trophy Experience & Fan Engagement",
        image: {
          src: "/projects/cwc-bd-hero.webp",
          alt: "Trophy Tour team behind the giant #CWCTrophy letters at Centre Court mall",
        },
        copy: "In Bangladesh, the ICC Cricket World Cup Trophy Tour created an interactive fan experience that brought audiences closer to the coveted trophy. Visitors were encouraged to participate in engaging activities including VR Cricket, the Batak Challenge and GIF Selfie, with 2,288 people capturing memorable moments with the trophy.",
        detail: {
          brand: "ICC Cricket World Cup Trophy Tour",
          name: "ICC Cricket World Cup Trophy Tour",
          subtitle: "ICC Cricket World Cup Trophy Tour",
          description: "2018 | Bangladesh | Trophy Experience & Fan Engagement",
          gallery: [
            {
              src: "/projects/cwc-bd-1.webp",
              alt: "Aerial view of the Trophy Tour mall activation with games booths and branded backdrop",
            },
            {
              src: "/projects/cwc-bd-2.webp",
              alt: "Trophy Tour team behind the giant #CWCTrophy letters at Centre Court mall",
            },
            {
              src: "/projects/cwc-bd-3.webp",
              alt: "The 'Are You Quick Enough?' Batak challenge reaction wall at the activation",
            },
            {
              src: "/projects/cwc-bd-4.webp",
              alt: "Young fan playing VR Cricket beside the branded stumps at the Trophy Tour",
            },
            {
              src: "/projects/cwc-bd-5.webp",
              alt: "The ICC World Cup trophy in its display case with Nissan-branded plinth",
            },
          ],
        },
      },
      {
        id: "icc-world-t20-trophy-tour",
        logo: "/projects/t20-logo.png",
        logoAlt: "ICC World Twenty20 India 2016 logo",
        logoClass: "h-[4.92rem] md:h-[6.0rem]",
        title: "ICC World Twenty20 Trophy & Promotional Tour",
        meta: "8-City Trophy Promotional Tour",
        image: {
          src: "/projects/t20-hero.webp",
          alt: "ICC World Twenty20 India 2016 trophy display with cricketer and officials giving a thumbs up",
        },
        copy: "The ICC World Twenty20 India 2016 Trophy & Promotional Tour brought the excitement of the tournament closer to fans across India. The campaign featured an 8-city trophy tour and an 8-city promotional tour, creating high-energy public experiences and generating over 5 lakh eyeballs through engaging on-ground activations.",
        detail: {
          brand: "ICC World Twenty20 Trophy & Promotional Tour",
          name: "ICC World Twenty20 Trophy & Promotional Tour",
          subtitle: "ICC World Twenty20 Trophy & Promotional Tour",
          description: "8-City Trophy Promotional Tour",
          gallery: [
            {
              src: "/projects/t20-1.webp",
              alt: "Branded ICC World Twenty20 double-decker bus touring Kolkata with police escort",
            },
            {
              src: "/projects/t20-2.webp",
              alt: "Dancers with pink flags performing in front of the ICC World Twenty20 Nissan Trophy Tour bus",
            },
            {
              src: "/projects/t20-3.webp",
              alt: "ICC World Twenty20 India 2016 trophy display with cricketer and officials giving a thumbs up",
            },
            {
              src: "/projects/t20-4.webp",
              alt: "Cricketer playing a promotional cricket game with young fans during the tour",
            },
            {
              src: "/projects/t20-5.webp",
              alt: "Schoolchildren cheering with the ICC World Twenty20 trophy aboard the tour bus",
            },
          ],
        },
      },
      {
        id: "clash-of-the-baddies",
        logo: "/projects/star-sports-logo.png",
        logoAlt: "Star Sports logo",
        logoClass: "h-[4.92rem] md:h-[6.0rem]",
        detailLogoClass: "h-[4.388rem] md:h-[5.363rem]",
        title: "Clash Of The Baddies | 2017–2019",
        meta: "2017–2019 | 3 Cities | Prelude to PBL 2017",
        image: {
          src: "/projects/baddies-hero.webp",
          alt: "Clash of the Baddies 2019 winners with medals and the golden shuttle trophy",
        },
        copy: "Clash of the Baddies was a multi-city badminton championship designed as a prelude to the Pro Badminton League, engaging media buying houses across Bengaluru, Delhi and Mumbai. Over three years, the platform brought together 400+ participants through competitive matches, networking and experiential engagement, supported by end-to-end league management and customised player kits.",
        detail: {
          brand: "Clash of the Baddies",
          name: "Clash of the Baddies",
          subtitle: "Clash of the Baddies",
          description: "2017–2019 | 3 Cities | Prelude to PBL 2017",
          gallery: [
            {
              src: "/projects/baddies-1.webp",
              alt: "Clash of the Baddies 2019 team behind Star Sports and PBL branded boards",
            },
            {
              src: "/projects/baddies-2.webp",
              alt: "Golden shuttlecock trophies for the Winner and Runners Up at Clash of the Baddies",
            },
            {
              src: "/projects/baddies-3.webp",
              alt: "Multiple badminton courts in action at the Clash of the Baddies arena",
            },
            {
              src: "/projects/baddies-4.webp",
              alt: "Medal winners posing against the Star Sports, PBL and Clash of the Baddies backdrop",
            },
            {
              src: "/projects/baddies-5.webp",
              alt: "Clash of the Baddies 2019 winners with medals and the golden shuttle trophy",
            },
          ],
        },
      },
    ],
  },
  {
    slug: "retail-exhibition",
    label: "Retail & Exhibition",
    tagline: "Retail as theatre. Exhibitions as argument.",
    lede:
      "Flagship stores, in-store activations and exhibition pavilions built to make a visit feel like a story worth telling.",
    coverImage:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_work-portfolio-239/artifacts/e005bpvm_Retail%20%26%20Exhibition.jpeg",
    longMeta: true,
    events: [
      {
        id: "asics-tmm-expo",
        logo: "/projects/asics-logo.png",
        logoAlt: "ASICS logo",
        logoClass: "h-[2.881rem] md:h-[3.513rem]",
        title: "ASICS TMM Expo",
        meta: "MMRDA Ground, Mumbai",
        image: {
          src: "/projects/asics-1.webp",
          alt: "GEL-NIMBUS 22 Tata Mumbai Marathon limited edition wall at the ASICS TMM Expo",
        },
        copy: "ASICS created an immersive exhibition experience at MMRDA Ground ahead of the Tata Mumbai Marathon, showcasing its running-focused product range. The four-day expo featured an engaging virtual reality running game, attracting over 10,000 visitors and driving sales of more than 1,000 products, with revenues exceeding ₹30 lakh.",
        detail: {
          brand: "ASICS TMM Expo",
          name: "ASICS TMM Expo",
          subtitle: "ASICS TMM Expo",
          description: "MMRDA Ground, Mumbai",
          gallery: [
            {
              src: "/projects/asics-1.webp",
              alt: "GEL-NIMBUS 22 Tata Mumbai Marathon limited edition wall and reception desk at the ASICS expo",
            },
            {
              src: "/projects/asics-2.webp",
              alt: "Visitors browsing the STABLE and CUSHION shoe walls at the ASICS TMM Expo",
            },
            {
              src: "/projects/asics-3.webp",
              alt: "ASICS apparel racks with running tees and shorts at the expo",
            },
            {
              src: "/projects/asics-4.webp",
              alt: "Crowds at the ASICS expo hall with runner mannequins and product displays",
            },
            {
              src: "/projects/asics-5.webp",
              alt: "Full ASICS booth panorama with Long Distance Comfort and GEL-NIMBUS 22 branding",
            },
          ],
        },
      },
      {
        id: "under-armour-product-expo",
        logo: "/projects/ua-expo-logo.png",
        logoAlt: "Under Armour logo",
        logoClass: "h-[3.819rem] md:h-[4.657rem]",
        title: "Under Armour Product Expo",
        meta: "Product Expo | Jawaharlal Nehru Stadium | Airtel Half Marathon",
        image: {
          src: "/projects/ua-expo-hero.webp",
          alt: "Under Armour Product Expo booth — reception desk and illuminated brand wall",
        },
        copy: "Under Armour showcased its running-focused product range through an immersive exhibition at Jawaharlal Nehru Stadium ahead of the Airtel Half Marathon. The three-day experience welcomed over 10,000 visitors per day and drove the sale of more than 1,000 products, generating over ₹3 lakh in revenue.",
        detail: {
          brand: "Under Armour Product Expo",
          name: "Under Armour Product Expo",
          subtitle: "Under Armour Product Expo",
          description:
            "Product Expo | Jawaharlal Nehru Stadium | Airtel Half Marathon",
          gallery: [
            {
              src: "/projects/ua-expo-1.webp",
              alt: "Under Armour booth with HOVR neon sign, hexagonal shoe wall and #IndiaWill branding",
            },
            {
              src: "/projects/ua-expo-2.webp",
              alt: "Wide panorama of the Under Armour expo booth with reception desk and illuminated logo wall",
            },
            {
              src: "/projects/ua-expo-3.webp",
              alt: "Team members at the Under Armour apparel and footwear display",
            },
            {
              src: "/projects/ua-expo-4.webp",
              alt: "Under Armour apparel racks and red seating cubes at the expo",
            },
            {
              src: "/projects/ua-expo-5.webp",
              alt: "Visitor trying the Under Armour treadmill experience at the expo",
            },
            {
              src: "/projects/ua-expo-6.webp",
              alt: "Hexagonal shoe wall and neon R display at the Under Armour expo",
            },
          ],
        },
      },
      {
        id: "abfrl-pavilion",
        logo: "/projects/abfrl-logo.png",
        logoAlt: "Aditya Birla Fashion & Retail logo",
        logoClass: "h-[4.918rem] md:h-[5.998rem]",
        detailLogoClass: "h-[5.06rem] md:h-[6.19rem]",
        title: "Aditya Birla Fashion & Retail Pavilion",
        meta: "Fashion & Retail Pavilion | Multi-Brand Showcase",
        image: {
          src: "/projects/abfrl-hero.webp",
          alt: "Making India Beautiful wall with aurelia, Louis Philippe and masaba mannequins at the Aditya Birla pavilion",
        },
        copy: "The Aditya Birla Fashion & Retail Pavilion brought together multiple fashion brands in a unified showcase, creating an immersive retail-inspired experience through design, storytelling and display. The pavilion enabled visitors to discover and engage with diverse brands while creating strong visual impact and brand recall.",
        detail: {
          brand: "Aditya Birla Fashion & Retail Pavilion",
          name: "Aditya Birla Fashion & Retail Pavilion",
          subtitle: "Aditya Birla Fashion & Retail Pavilion",
          description: "Fashion & Retail Pavilion | Multi-Brand Showcase",
          gallery: [
            {
              src: "/projects/abfrl-1.webp",
              alt: "Wall of Sustainable Dreams and Aditya Birla Fashion logo panel at the pavilion",
            },
            {
              src: "/projects/abfrl-2.webp",
              alt: "New York Fashion Week 2025 display and Jaypore mannequins at the pavilion",
            },
            {
              src: "/projects/abfrl-3.webp",
              alt: "Louis Philippe and Allen Solly mannequin podium with framed brand walls — Making India Fashionable",
            },
            {
              src: "/projects/abfrl-4.webp",
              alt: "Allen Solly and Van Heusen frames with styled mannequins at the pavilion",
            },
            {
              src: "/projects/abfrl-5.webp",
              alt: "Pavilion exterior with Aditya Birla Fashion signage and Making India Beautiful wall",
            },
          ],
        },
      },
      {
        id: "yamaha-brand-experience",
        logo: "/projects/yamaha-logo.png",
        logoAlt: "Yamaha logo",
        logoClass: "h-[2.317rem] md:h-[2.825rem]",
        title: "Yamaha Brand Showcase",
        meta: "Brand Showcase | Instruments, Commercial Home Sound & Audio",
        image: {
          src: "/projects/yamaha-event.webp",
          alt: "Yamaha brand experience exhibition — keyboard and instrument showcase with visitors",
        },
        copy: "The Yamaha Brand Showcase brought together the brand’s diverse product verticals under one immersive experience, showcasing instruments, commercial home sound and professional audio solutions. Designed to create impact while maintaining Yamaha’s strong brand identity, the showcase highlighted the synergies between its different business verticals through an engaging and visually cohesive exhibition.",
        detail: {
          brand: "Yamaha Brand Showcase",
          name: "Yamaha Brand Showcase",
          subtitle: "Yamaha Brand Showcase",
          description:
            "Brand Showcase | Instruments, Commercial Home Sound & Audio",
          gallery: [
            {
              src: "/projects/yamaha-1.webp",
              alt: "Yamaha guitar wall display at the Brand Showcase",
            },
            {
              src: "/projects/yamaha-2.webp",
              alt: "Yamaha keyboard range — True Indian sounds showcase",
            },
            {
              src: "/projects/yamaha-3.webp",
              alt: "Yamaha piano gallery — Superb acoustic for a full range of expression",
            },
            {
              src: "/projects/yamaha-4.webp",
              alt: "Yamaha drum kits and NEXO professional audio zone",
            },
            {
              src: "/projects/yamaha-5.webp",
              alt: "Yamaha motorcycles display — Two Yamahas, One Passion",
            },
          ],
        },
      },
      {
        id: "khelo-india-pavilion",
        logo: "/projects/khelo-india-logo.png",
        logoAlt: "Khelo India logo",
        logoClass: "h-[3.901rem] md:h-[4.757rem]",
        detailLogoClass: "h-[5.06rem] md:h-[6.19rem]",
        title: "Khelo India – Cradle to Medal",
        meta: "Sports Pavilion | Showcasing Haryana’s Sporting Legacy",
        image: {
          src: "/projects/khelo-2.webp",
          alt: "Athlete panels of Neeraj Chopra, Saina Nehwal and Yuzvendra Chahal inside the Khelo India pavilion",
        },
        copy: "The Khelo India pavilion celebrated Haryana’s sporting legacy, showcasing the journey from emerging talent to global champions. Featuring sporting icons such as Kapil Dev and Neeraj Chopra, alongside state initiatives supporting athletes, the experience highlighted Haryana’s grassroots sporting ecosystem and its continued contribution to India’s sporting success.",
        detail: {
          brand: "Khelo India – Cradle to Medal",
          name: "Khelo India – Cradle to Medal",
          subtitle: "Khelo India – Cradle to Medal",
          description:
            "Sports Pavilion | Showcasing Haryana’s Sporting Legacy",
          gallery: [
            {
              src: "/projects/khelo-1.webp",
              alt: "Achievers Arena — the Khelo India pavilion with athlete panels and From Cradle to Medal banners",
            },
            {
              src: "/projects/khelo-2.webp",
              alt: "Neeraj Chopra, Saina Nehwal and Yuzvendra Chahal panels inside the Achievers Arena",
            },
            {
              src: "/projects/khelo-3.webp",
              alt: "Kapil Dev tribute panel at the Khelo India pavilion",
            },
            {
              src: "/projects/khelo-4.webp",
              alt: "Framed Team India jerseys and hockey stick display at the Khelo India pavilion",
            },
            {
              src: "/projects/khelo-5.webp",
              alt: "Cradle to Medal information wall — sports nurseries and Khelo India Youth Games initiatives",
            },
          ],
        },
      },
    ],
  },
];

// Convenience lookup by slug
export const CATEGORY_BY_SLUG = Object.fromEntries(
  CATEGORIES.map((c) => [c.slug, c])
);
